import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode, vShow as _vShow, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "q-gutter-md",
  style: {"max-width":"500px"}
}
const _hoisted_2 = { class: "row items-start q-gutter-sm" }
const _hoisted_3 = { class: "q-mt-md" }
const _hoisted_4 = {
  ref: "createMiniMap",
  style: {"height":"250px","width":"100%","border":"1px solid #ccc","border-radius":"4px"}
}
const _hoisted_5 = {
  class: "q-gutter-md",
  style: {"max-width":"500px"}
}
const _hoisted_6 = { class: "row items-start q-gutter-sm" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "row items-center q-gutter-sm" }
const _hoisted_9 = { class: "text-body2" }
const _hoisted_10 = { class: "row q-gutter-sm" }
const _hoisted_11 = { class: "q-mt-md" }
const _hoisted_12 = {
  ref: "miniMap",
  style: {"height":"250px","width":"100%","border":"1px solid #ccc","border-radius":"4px"}
}
const _hoisted_13 = { style: {"white-space":"pre-wrap","word-break":"break-all","font-size":"13px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_toolbar_title = _resolveComponent("q-toolbar-title")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_q_tab = _resolveComponent("q-tab")!
  const _component_q_tabs = _resolveComponent("q-tabs")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_file = _resolveComponent("q-file")!
  const _component_q_tab_panel = _resolveComponent("q-tab-panel")!
  const _component_q_tab_panels = _resolveComponent("q-tab-panels")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _component_InstructionCard = _resolveComponent("InstructionCard")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_q_dialog, {
      "model-value": _ctx.modelValue,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.$emit('update:modelValue', $event)))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, {
          style: {"width":"540px","max-width":"95vw"},
          class: "manage-ps-dialog"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_toolbar, { class: "bg-blue-brand text-white" }, {
              default: _withCtx(() => [
                _createVNode(_component_q_toolbar_title, null, {
                  default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                    _createTextVNode("Pipeline Manager", -1)
                  ]))]),
                  _: 1
                }),
                _withDirectives(_createVNode(_component_q_btn, {
                  flat: "",
                  round: "",
                  dense: "",
                  icon: "close"
                }, null, 512), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_q_tabs, {
              modelValue: _ctx.tab,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tab) = $event)),
              dense: "",
              class: "text-grey",
              "active-color": "blue-brand",
              "indicator-color": "blue-brand",
              align: "left",
              "update-csv-file": "",
              "narrow-indicator": ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_tab, {
                  name: "create",
                  label: "Create New"
                }),
                _createVNode(_component_q_tab, {
                  name: "update",
                  label: "Update Existing"
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_q_separator),
            _createVNode(_component_q_tab_panels, {
              modelValue: _ctx.tab,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.tab) = $event)),
              animated: "",
              "keep-alive": ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_tab_panel, { name: "create" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                      _createVNode(_component_q_input, {
                        modelValue: _ctx.createName,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.createName) = $event)),
                        dense: "",
                        outlined: "",
                        color: "blue-brand",
                        label: "Name e.g., Oklahoma City to Tulsa",
                        error: _ctx.createNameError !== '',
                        "error-message": _ctx.createNameError
                      }, null, 8, ["modelValue", "error", "error-message"]),
                      _createElementVNode("div", _hoisted_2, [
                        _createVNode(_component_q_input, {
                          modelValue: _ctx.createDiameter,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.createDiameter) = $event)),
                          dense: "",
                          outlined: "",
                          color: "blue-brand",
                          label: 
                  'Diameter (' +
                  (_ctx.createDiameterUnit === 'in' ? 'inches' : 'cm') +
                  ')'
                ,
                          error: _ctx.createDiameterError !== '',
                          "error-message": _ctx.createDiameterError,
                          rules: [_ctx.createDiameterRule],
                          "reactive-rules": "",
                          class: "col"
                        }, null, 8, ["modelValue", "label", "error", "error-message", "rules"]),
                        _createVNode(_component_q_select, {
                          modelValue: _ctx.createDiameterUnit,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.createDiameterUnit) = $event)),
                          dense: "",
                          outlined: "",
                          color: "blue-brand",
                          options: [
                  { label: 'in', value: 'in' },
                  { label: 'cm', value: 'cm' },
                ],
                          "emit-value": "",
                          "map-options": "",
                          style: {"width":"90px"}
                        }, null, 8, ["modelValue"])
                      ]),
                      _createVNode(_component_q_file, {
                        modelValue: _ctx.createCsvFile,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.createCsvFile) = $event)),
                        dense: "",
                        outlined: "",
                        color: "blue-brand",
                        label: "Survey Markers and Tracking Locations (CSV) File Upload",
                        accept: ".csv",
                        clearable: "",
                        error: _ctx.createCsvFileError !== '',
                        "error-message": _ctx.createCsvFileError
                      }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_q_icon, { name: "attach_file" })
                        ]),
                        _: 1
                      }, 8, ["modelValue", "error", "error-message"]),
                      _createElementVNode("div", null, [
                        _createVNode(_component_q_btn, {
                          class: "btn-brand",
                          label: "Create",
                          loading: _ctx.loading,
                          onClick: _ctx.onCreateSubmit
                        }, null, 8, ["loading", "onClick"])
                      ]),
                      _withDirectives(_createElementVNode("div", _hoisted_3, [
                        _cache[14] || (_cache[14] = _createElementVNode("div", { class: "text-caption text-grey-8 q-mb-xs" }, " Pipeline Preview ", -1)),
                        _createElementVNode("div", _hoisted_4, null, 512)
                      ], 512), [
                        [_vShow, _ctx.createCsvFile]
                      ])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_tab_panel, { name: "update" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_q_select, {
                        modelValue: _ctx.selectedPipelineSection,
                        "onUpdate:modelValue": [
                          _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedPipelineSection) = $event)),
                          _ctx.onPipelineSectionSelected
                        ],
                        dense: "",
                        outlined: "",
                        color: "blue-brand",
                        label: "Name",
                        options: _ctx.pipelineSectionOptions,
                        loading: _ctx.loading,
                        clearable: "",
                        onClear: _ctx.onPipelineSectionCleared
                      }, null, 8, ["modelValue", "options", "loading", "onUpdate:modelValue", "onClear"]),
                      _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_q_input, {
                          modelValue: _ctx.updateDiameter,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.updateDiameter) = $event)),
                          dense: "",
                          outlined: "",
                          color: "blue-brand",
                          label: 
                  'Diameter (' +
                  (_ctx.updateDiameterUnit === 'in' ? 'inches' : 'cm') +
                  ')'
                ,
                          disable: !_ctx.selectedPipelineSection,
                          rules: [(val) => !!val || 'Diameter is required.'],
                          class: "col"
                        }, null, 8, ["modelValue", "label", "disable", "rules"]),
                        _createVNode(_component_q_select, {
                          modelValue: _ctx.updateDiameterUnit,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.updateDiameterUnit) = $event)),
                          dense: "",
                          outlined: "",
                          color: "blue-brand",
                          options: [
                  { label: 'in', value: 'in' },
                  { label: 'cm', value: 'cm' },
                ],
                          "emit-value": "",
                          "map-options": "",
                          disable: !_ctx.selectedPipelineSection,
                          style: {"width":"90px"}
                        }, null, 8, ["modelValue", "disable"])
                      ]),
                      (_ctx.selectedPipelineSection && _ctx.currentTrackingFileName)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _cache[15] || (_cache[15] = _createElementVNode("div", { class: "text-caption text-grey-8 q-mb-xs" }, " Current Tracking File ", -1)),
                            _createElementVNode("div", _hoisted_8, [
                              _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.currentTrackingFileName), 1),
                              _createVNode(_component_q_btn, {
                                flat: "",
                                dense: "",
                                size: "sm",
                                icon: "visibility",
                                color: "blue-brand",
                                title: "View file",
                                onClick: _ctx.onViewTrackingFile
                              }, null, 8, ["onClick"]),
                              _createVNode(_component_q_btn, {
                                flat: "",
                                dense: "",
                                size: "sm",
                                icon: "download",
                                color: "blue-brand",
                                title: "Download file",
                                onClick: _ctx.onDownloadTrackingFile
                              }, null, 8, ["onClick"])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_q_file, {
                        modelValue: _ctx.updateCsvFile,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.updateCsvFile) = $event)),
                        dense: "",
                        outlined: "",
                        color: "blue-brand",
                        label: "Survey Markers and Tracking Locations (CSV) File Upload",
                        accept: ".csv",
                        clearable: "",
                        disable: !_ctx.selectedPipelineSection
                      }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_q_icon, { name: "attach_file" })
                        ]),
                        _: 1
                      }, 8, ["modelValue", "disable"]),
                      _createElementVNode("div", _hoisted_10, [
                        _createVNode(_component_q_btn, {
                          class: "btn-brand",
                          label: "Update",
                          disable: !_ctx.selectedPipelineSection,
                          loading: _ctx.loading,
                          onClick: _ctx.onUpdateSubmit
                        }, null, 8, ["disable", "loading", "onClick"]),
                        _createVNode(_component_q_btn, {
                          color: "negative",
                          label: "Delete",
                          disable: !_ctx.selectedPipelineSection,
                          loading: _ctx.loading,
                          onClick: _ctx.onDeleteSubmit
                        }, null, 8, ["disable", "loading", "onClick"])
                      ]),
                      _withDirectives(_createElementVNode("div", _hoisted_11, [
                        _cache[16] || (_cache[16] = _createElementVNode("div", { class: "text-caption text-grey-8 q-mb-xs" }, " Pipeline Preview ", -1)),
                        _createElementVNode("div", _hoisted_12, null, 512)
                      ], 512), [
                        [_vShow, _ctx.selectedPipelineSection && _ctx.currentTrackingFile]
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_q_dialog, {
          modelValue: _ctx.viewTrackingFileDialog,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.viewTrackingFileDialog) = $event)),
          maximized: "",
          onHide: _ctx.onViewTrackingFileDialogHide
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_toolbar, { class: "bg-blue-brand text-white" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_toolbar_title, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.currentTrackingFileName), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_q_btn, {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "download",
                      title: "Download",
                      onClick: _ctx.onDownloadTrackingFile
                    }, null, 8, ["onClick"]),
                    _withDirectives(_createVNode(_component_q_btn, {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "close"
                    }, null, 512), [
                      [_directive_close_popup]
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_card_section, {
                  class: "q-pa-md",
                  style: {"overflow":"auto","max-height":"calc(100vh - 50px)"}
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("pre", _hoisted_13, _toDisplayString(_ctx.currentTrackingFile), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue", "onHide"])
      ]),
      _: 1
    }, 8, ["model-value"]),
    _createVNode(_component_InstructionCard, {
      modelValue: _ctx.showInstructions,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.showInstructions) = $event)),
      title: "Pipelines",
      icon: "description",
      message: "Create a pipeline by entering a name, diameter, and uploading a CSV file with your marker positions.",
      tip: "Download an example CSV to see the expected format.",
      "tip-action-label": "Download example CSV",
      "z-index": 7000,
      onTipAction: _ctx.onDownloadExampleCsv
    }, null, 8, ["modelValue", "onTipAction"])
  ], 64))
}